import React from "react";
import './PaperItemPurchase.scss'
import {Button, Col, Row} from "reactstrap";
import {lang, language} from "../../const/language";
import Slider from "react-slick";
import * as actionModalCreator from "../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as constants from "../../const/constants";
import {getSliderSetting} from "../../utils/commonFunc";
import moment from "moment";

class PaperItem extends React.Component {
    viewPaper = (papers) => {
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_SELECTED_PAPER_ROUTE}`,
            state: {...papers, classId: this.props.classId}
        })
    };

    convertMinsToHrsMins = (minutes) => {
        let h = Math.floor(minutes / 60);
        let m = Math.round(minutes % 60);
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        let type = h === '00' ? 'min' : 'hours';
        return h + ':' + m + ' ' + type;
    }

    render() {
        const {papers, classId} = this.props;
        let settings = getSliderSetting(papers);

        return (
            <div>
                <div className="paper-item-purchase">
                    <Slider {...settings}>
                        {
                            papers.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <div className={`slideshow-wrapper shadow border-0 card`}>
                                            <div className={"display-inline slideshow-user-wrapper"}>
                                                <img
                                                    src={"https://i.stack.imgur.com/J9wGf.jpg"}
                                                    alt={"."}
                                                    className={"slideshow-pro-image"}/>
                                                <div className={"slideshow-middle"}>
                                                    <div className={"cursor minHeight mb-3"}>
                                                        <div onClick={() => this.viewPaper(item)}>
                                                            <h4 className={"topic"}>{item.title}</h4>
                                                            <h6 className={"topic"}>
                                                                {
                                                                    this.convertMinsToHrsMins(item.paperDuration)
                                                                }

                                                                {/*{*/}
                                                                {/*    Number(item.paperDuration) % 60 !== 0 &&*/}
                                                                {/*    <p> and {Number(item.paperDuration) % 60} minutes </p>*/}
                                                                {/*}*/}
                                                                &nbsp;
                                                                {item.quizType} Paper </h6>

                                                            <Row className={"card-row"}>
                                                                <Col xs="12"><p
                                                                    className={"description"}>
                                                                    Start on
                                                                    {` ${moment(item.startDateTime.replace("Z", "")).format("YYYY MMM DD ")}`} at
                                                                    {` ${moment(item.startDateTime.replace("Z", "")).format("h:mm a ")}`}
                                                                    <br/>
                                                                    Expire on
                                                                    {` ${moment(item.endDateTime.replace("Z", "")).format("YYYY MMM DD ")}`} at
                                                                    {` ${moment(item.endDateTime.replace("Z", "")).format("h:mm a ")}`}
                                                                </p>
                                                                </Col>
                                                            </Row>
                                                            <Row>

                                                            </Row>
                                                        </div>
                                                        <div className={"btn-ctrl"}>
                                                            <Button className={"reg-btn com-btn bold-text"}
                                                                    onClick={() => this.viewPaper(item)}>
                                                                {language[lang].viewPaperBtnText}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PaperItem));
/* Created By Janitha Prashad Katukenda
 jpk Created on Thu Dec 10 2020
Copyright (c) 2020 Ceyentra Technologies
EDULAB */

